<template>
  <!-- Feature Course -->
  <section class="featured-courses-sec">
    <div class="patter-bg">
      <img class="patter-one" src="@/assets/img/bg/bg-13.png" alt="Img" />
    </div>
    <div class="container">
      <div class="section-header text-center">
        <span class="fw-medium text-secondary fs-18 fw-bold mb-2 d-inline-block"
          >What’s New</span
        >
        <h2>Featured Courses</h2>
        <p>Get certified, master modern tech skills, and level up your career</p>
      </div>
      <div class="featured-courses-two">
        <div class="row">
          <!-- Featured Courses -->
          <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 d-flex" data-aos="fade-down">
            <div class="course-item course-item-four mx-0">
              <div class="course-img">
                <a href="course-details.html">
                  <img
                    class="img-fluid"
                    alt="Img"
                    src="@/assets/img/course/course-10.jpg"
                  />
                </a>
                <div
                  class="position-absolute start-0 top-0 d-flex align-items-start w-100 z-index-2 p-2"
                >
                  <a href="javascript:void(0);" class="course-name">PHP</a>
                </div>
              </div>
              <div class="course-content">
                <div class="rating">
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <span class="ms-2">203 reviews</span>
                </div>
                <h3 class="title">
                  <a href="course-details.html"
                    >The Complete Web Developer PHP framework Course 2.0</a
                  >
                </h3>
                <div class="user-info">
                  <p class="user-name">
                    <a href="instructor-details.html" class="link-info">Emily Williams</a>
                  </p>
                  <p class="course-level">Expert</p>
                </div>
                <div class="course-info">
                  <p class="course-time">
                    <i class="fa-regular fa-clock me-2"></i>6hr 30min
                  </p>
                  <h5 class="price">$400 <span>$99.00</span></h5>
                </div>
              </div>
            </div>
          </div>
          <!-- /Featured Courses -->

          <!-- Featured Courses -->
          <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 d-flex" data-aos="fade-down">
            <div class="course-item course-item-four mx-0">
              <div class="course-img">
                <a href="course-details.html">
                  <img
                    class="img-fluid"
                    alt="Img"
                    src="@/assets/img/course/course-11.jpg"
                  />
                </a>
                <div
                  class="position-absolute start-0 top-0 d-flex align-items-start w-100 z-index-2 p-2"
                >
                  <a href="javascript:void(0);" class="course-name">Self Improvements</a>
                </div>
              </div>
              <div class="course-content">
                <div class="rating">
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <span class="ms-2">5.0 (22 Reviews)</span>
                </div>
                <h3 class="title">
                  <a href="course-details.html"
                    >Building Your Personal Brand: Tips for Career Success</a
                  >
                </h3>
                <div class="user-info">
                  <p class="user-name">
                    <a href="instructor-details.html" class="link-info">Brook Salaine</a>
                  </p>
                  <p class="course-level text-warning">Intermediate</p>
                </div>
                <div class="course-info">
                  <p class="course-time">
                    <i class="fa-regular fa-clock me-2"></i>1hr 20min
                  </p>
                  <h5 class="price">$125</h5>
                </div>
              </div>
            </div>
          </div>
          <!-- /Featured Courses -->

          <!-- Featured Courses -->
          <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 d-flex" data-aos="fade-down">
            <div class="course-item course-item-four mx-0">
              <div class="course-img">
                <a href="course-details.html">
                  <img
                    class="img-fluid"
                    alt="Img"
                    src="@/assets/img/course/course-12.jpg"
                  />
                </a>
                <div
                  class="position-absolute start-0 top-0 d-flex align-items-start w-100 z-index-2 p-2"
                >
                  <a href="javascript:void(0);" class="course-name">Finance</a>
                </div>
              </div>
              <div class="course-content">
                <div class="rating">
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <span class="ms-2">4.0 (15 Reviwes) </span>
                </div>
                <h3 class="title">
                  <a href="course-details.html"
                    >Strength Training 101: Building a Solid Foundation</a
                  >
                </h3>
                <div class="user-info">
                  <p class="user-name">
                    <a href="instructor-details.html" class="link-info"
                      >Mark Richardson</a
                    >
                  </p>
                  <p class="course-level text-purple">Basic</p>
                </div>
                <div class="course-info">
                  <p class="course-time">
                    <i class="fa-regular fa-clock me-2"></i>2hr 30min
                  </p>
                  <h5 class="price">$3560</h5>
                </div>
              </div>
            </div>
          </div>
          <!-- /Featured Courses -->

          <!-- Featured Courses -->
          <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 d-flex" data-aos="fade-down">
            <div class="course-item course-item-four mx-0">
              <div class="course-img">
                <a href="course-details.html">
                  <img
                    class="img-fluid"
                    alt="Img"
                    src="@/assets/img/course/course-13.jpg"
                  />
                </a>
                <div
                  class="position-absolute start-0 top-0 d-flex align-items-start w-100 z-index-2 p-2"
                >
                  <a href="javascript:void(0);" class="course-name">SEO</a>
                </div>
              </div>
              <div class="course-content">
                <div class="rating">
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <span class="ms-2">203 reviews</span>
                </div>
                <h3 class="title">
                  <a href="course-details.html"
                    >Digital Marketing Strategies for Business Growth</a
                  >
                </h3>
                <div class="user-info">
                  <p class="user-name">
                    <a href="instructor-details.html" class="link-info">Laura Bennett</a>
                  </p>
                  <p class="course-level text-purple">Basic</p>
                </div>
                <div class="course-info">
                  <p class="course-time">
                    <i class="fa-regular fa-clock me-2"></i>6hr 30min
                  </p>
                  <h5 class="price">$350 <span>$699.00</span></h5>
                </div>
              </div>
            </div>
          </div>
          <!-- /Featured Courses -->

          <!-- Featured Courses -->
          <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 d-flex" data-aos="fade-down">
            <div class="course-item course-item-four mx-0">
              <div class="course-img">
                <a href="course-details.html">
                  <img
                    class="img-fluid"
                    alt="Img"
                    src="@/assets/img/course/course-14.jpg"
                  />
                </a>
                <div
                  class="position-absolute start-0 top-0 d-flex align-items-start w-100 z-index-2 p-2"
                >
                  <a href="javascript:void(0);" class="course-name">Development</a>
                </div>
              </div>
              <div class="course-content">
                <div class="rating">
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <span class="ms-2">5.0 (05 Reviews)</span>
                </div>
                <h3 class="title">
                  <a href="course-details.html"
                    >Web Development for Beginners: HTML, CSS, and JavaScript</a
                  >
                </h3>
                <div class="user-info">
                  <p class="user-name">
                    <a href="instructor-details.html" class="link-info">David Morgan</a>
                  </p>
                  <p class="course-level">Expert</p>
                </div>
                <div class="course-info">
                  <p class="course-time">
                    <i class="fa-regular fa-clock me-2"></i>1hr 15min
                  </p>
                  <h5 class="price">$150</h5>
                </div>
              </div>
            </div>
          </div>
          <!-- /Featured Courses -->

          <!-- Featured Courses -->
          <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 d-flex" data-aos="fade-down">
            <div class="course-item course-item-four mx-0">
              <div class="course-img">
                <a href="course-details.html">
                  <img
                    class="img-fluid"
                    alt="Img"
                    src="@/assets/img/course/course-15.jpg"
                  />
                </a>
                <div
                  class="position-absolute start-0 top-0 d-flex align-items-start w-100 z-index-2 p-2"
                >
                  <a href="javascript:void(0);" class="course-name">PHP</a>
                </div>
              </div>
              <div class="course-content">
                <div class="rating">
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <span class="ms-2">203 reviews</span>
                </div>
                <h3 class="title">
                  <a href="course-details.html"
                    >Photography Basics: Understanding Composition and Lighting</a
                  >
                </h3>
                <div class="user-info">
                  <p class="user-name">
                    <a href="instructor-details.html" class="link-info">Maria Lopez</a>
                  </p>
                  <p class="course-level text-pink">Advanced</p>
                </div>
                <div class="course-info">
                  <p class="course-time">
                    <i class="fa-regular fa-clock me-2"></i>2hr 40min
                  </p>
                  <h5 class="price">$250</h5>
                </div>
              </div>
            </div>
          </div>
          <!-- /Featured Courses -->
        </div>
      </div>
      <!-- View all  Courses -->
      <div class="col-lg-12" data-aos="fade-up">
        <div class="more-details text-center">
          <a href="course-list.html" class="btn btn-secondary btn-xl"
            >View all Courses
          </a>
        </div>
      </div>
      <!-- /View all  Courses -->
    </div>
  </section>
  <!-- /Feature Course -->

  <!-- Master Skills -->
  <section class="master-skills-sec pt-0">
    <div class="container">
      <div class="row">
        <div class="col-lg-7 mx-auto">
          <div class="section-header text-center">
            <span class="fw-medium text-secondary fs-18 fw-bold mb-2 d-inline-block"
              >What’s New</span
            >
            <h2>Master the skills to drive your career</h2>
            <p>
              Get certified, master modern tech skills, and level up your career — whether
              you’re starting out or a seasoned pro. 95% of eLearning learners report.
            </p>
          </div>
        </div>
      </div>
      <!-- Course Info-->
      <div class="course-info-two">
        <div class="skills-item">
          <div class="skills-wrap">
            <div class="row row-gap-4 align-items-center">
              <!-- Master skills Content -->
              <div
                class="col-xl-5 col-lg-6 col-md-12 order-lg-0 order-md-0 order-0"
                data-aos="fade-up"
              >
                <h3>Award Winning Course Management</h3>
                <p>
                  An award-winning course management system (CMS) or program is typically
                  recognized for its exceptional quality, innovation, and effectiveness in
                  helping both instructors and students succeed.
                </p>

                <ul class="list-unstyled heading-color mb-4">
                  <li class="d-flex mb-3">
                    <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i
                    >Interactive Tools for Engagement
                  </li>
                  <li class="d-flex mb-3">
                    <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i
                    >Customizable Course Creation
                  </li>
                  <li class="d-flex mb-3 aos-init aos-animate">
                    <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>Robust
                    Analytics and Reporting
                  </li>
                  <li class="d-flex mb-3 aos-init aos-animate">
                    <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i
                    >Collaborative and Peer to Peer Learning
                  </li>
                  <li class="d-flex mb-3 aos-init aos-animate">
                    <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>The Most
                    World Class Instructors
                  </li>
                </ul>
              </div>
              <!-- /Master skills Content -->

              <!-- Master skills Image -->
              <div
                class="col-xl-7 col-lg-6 col-md-12 order-lg-1 order-md-1 order-1"
                data-aos="fade-up"
              >
                <div class="join-mentor-img">
                  <img
                    src="@/assets/img/feature/feature-18.jpg"
                    alt="Img"
                    class="img-fluid rounded-4"
                  />
                  <div class="joing-icon-award bg-warning">
                    <img
                      src="@/assets/img/icons/award-01.svg"
                      alt="Img"
                      class="img-fluid"
                    />
                  </div>
                </div>
              </div>
              <!-- /Master skills Image -->
            </div>
          </div>
        </div>

        <div class="skills-item">
          <div class="skills-wrap skill-center">
            <div class="row row-gap-4 align-items-center">
              <!-- Master skills Content -->
              <div
                class="col-xl-7 col-lg-7 col-md-12 order-lg-2 order-md-3 order-3"
                data-aos="fade-up"
              >
                <div class="join-mentor-img">
                  <img
                    src="@/assets/img/feature/feature-19.jpg"
                    alt="Img"
                    class="img-fluid rounded-4"
                  />
                  <div class="joing-icon-award bg-success">
                    <img
                      src="@/assets/img/icons/award-02.svg"
                      alt="Img"
                      class="img-fluid"
                    />
                  </div>
                </div>
              </div>
              <!-- /Master skills Content -->

              <!-- Master skills Image -->
              <div
                class="col-xl-5 col-lg-5 col-md-12 order-lg-3 order-md-2 order-2"
                data-aos="fade-up"
              >
                <h3>Learn anything from anywhere anytime</h3>
                <p>
                  In today’s fast-paced, digital world, the ability to learn anything,
                  from anywhere, and at any time is more accessible than ever. Whether you
                  are looking to expand your knowledge, gain new skills.
                </p>
                <ul class="list-unstyled heading-color mb-4">
                  <li class="d-flex mb-3">
                    <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>Access
                    to a World of Knowledge
                  </li>
                  <li class="d-flex mb-3">
                    <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>Diverse
                    Learning Formats
                  </li>
                  <li class="d-flex mb-3 aos-init">
                    <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>Learn at
                    Your Own Pace
                  </li>
                  <li class="d-flex mb-3 aos-init">
                    <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i
                    >Affordable and Flexible Pricing
                  </li>
                  <li class="d-flex mb-3 aos-init">
                    <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>The Most
                    World Class Instructors
                  </li>
                </ul>
              </div>
              <!-- /Master skills Image -->
            </div>
          </div>
        </div>

        <div class="skills-item">
          <div class="skills-wrap">
            <div class="row row-gap-4 align-items-center">
              <!-- Master skills Content -->
              <div
                class="col-xl-5 col-lg-7 col-md-12 order-lg-4 order-md-4 order-4"
                data-aos="fade-up"
              >
                <h3>Certification for solid development of your Career</h3>
                <p>
                  Certifications are a powerful way to enhance your skills, build
                  credibility, and boost your career growth. In today’s competitive job
                  market, a professional certification
                </p>
                <ul class="list-unstyled heading-color mb-4">
                  <li class="d-flex mb-3">
                    <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i
                    >Demonstrates Expertise
                  </li>
                  <li class="d-flex mb-3">
                    <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>Boosts
                    Your Credibility
                  </li>
                  <li class="d-flex mb-3 aos-init">
                    <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>Improves
                    Job Security
                  </li>
                  <li class="d-flex mb-3 aos-init">
                    <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i
                    >Facilitates Career Advancement
                  </li>
                  <li class="d-flex mb-3 aos-init">
                    <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>Fosters
                    Personal Growth
                  </li>
                </ul>
              </div>
              <!-- /Master skills Content -->

              <!-- Master skills Image -->
              <div
                class="col-xl-7 col-lg-5 col-md-12 order-lg-5 order-md-5 order-5"
                data-aos="fade-up"
              >
                <div class="join-mentor-img">
                  <img
                    src="@/assets/img/feature/feature-20.jpg"
                    alt="Img"
                    class="img-fluid rounded-4"
                  />
                  <div class="joing-icon-award bg-secondary">
                    <img
                      src="@/assets/img/icons/award-03.svg"
                      alt="Img"
                      class="img-fluid"
                    />
                  </div>
                </div>
              </div>
              <!-- /Master skills Image -->
            </div>
          </div>
        </div>
      </div>
      <!-- /Course Info -->
    </div>
  </section>
  <!-- /Master Skills -->
</template>
<script>
import AOS from "aos";
import "aos/dist/aos.css";
export default {
  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {
      AOS.init();
    });
  },
};
</script>
